<template>
  <q-page fluid style="min-height: 0px; top: 30vh">
    <div
      :style="`height: 30vh; width: 100vw; position: fixed; top: 0; left: 0`"
    >
      <googleMaps
        v-if="!offlineMode"
        ref="gmapReport"
        :center="{ lng: coords.lng, lat: coords.lat }"
        :zoom="5"
        :upperLimit="upperLimit"
        :lowerLimit="lowerLimit"
        mapType="roadmap"
        :normalizedData="normalizedData"
        :profileData="currentZoomScanData"
        :overlayAllData="overlayAllData"
        :polyline="line"
        :dot="dot"
        :showRangeCircles="graph"
        :options="{
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: true,
        }"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        @dotClicked="dotClicked"
        @zoomLevelChanged="handleNewZoomLevel"
      >
      </googleMaps>
      <leaflet-maps
        v-if="offlineMode"
        ref="gmapReport"
        :center="{ lng: coords.lng, lat: coords.lat }"
        :zoom="18"
        :upperLimit="upperLimit"
        :lowerLimit="lowerLimit"
        mapType="roadmap"
        :normalizedData="normalizedData"
        :profileData="currentZoomScanData"
        :overlayAllData="overlayAllData"
        :polyline="line"
        :dot="dot"
        :options="{
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: true,
        }"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        @dotClicked="dotClicked"
      >
      </leaflet-maps>
    </div>
    <div class="row q-pt-md" style="position: relative; background: white">
      <div class="col-12">
        <q-checkbox
          class="q-mr-md"
          dense
          v-model="dot"
          label="Dots"
          color="primary"
        />
        <q-checkbox
          class="q-mr-md"
          dense
          v-model="line"
          label="Line"
          color="primary"
        />
        <!-- <q-checkbox
          dense
          v-model="graph"
          class="q-mr-md"
          label="Graph"
          color="primary"
          @input="toggleGraphSettings"
        /> -->
        <q-btn
          @click="settingsDialog = !settingsDialog"
          size="sm"
          style="right: 0px; position: absolute; top: 10px"
          flat
          round
          color="black"
          icon="mdi-cog"
        />
      </div>
      <div v-if="render" class="col-12 q-mb-sm">
        <div style="position: relative">
          <svg
            style="position: absolute; top: 25%; height: 100%"
            width="100%"
            preserveAspectRatio="none"
            :viewBox="`0 0 ${currentZoomScanData[currentMapIndex].normalizedData.length} 4`"
          >
            <rect
              v-for="(path, index) in currentZoomScanData[currentMapIndex]
                .normalizedData"
              :key="index"
              :x="index"
              y="0"
              width="1"
              height="2"
              :fill="
                strokeColors[
                  path.value < lowerLimit ? 0 : path.value > upperLimit ? 2 : 1
                ]
              "
              :fill-opacity="
                index < geoPointRecordingRange.min ||
                index > geoPointRecordingRange.max
                  ? '0.5'
                  : '1.0'
              "
              stroke-opacity="0"
            />

            Sorry, your browser does not support inline SVG.
          </svg>

          <q-slider
            id="reportSlider"
            color="black"
            v-model="slider"
            :min="sliderOptions.min"
            :max="sliderOptions.max"
            @input="updateCenterPOS"
          />
        </div>

        <!-- <div
          v-for="(scan, index) in surveyReports[0].scans"
          :key="`scan_${index}`"
          class="row q-px-lg"
        >
          <div class="col-6">
            <p
              class="q-my-none"
              v-if="surveyReports[0].type != 'Single Depth Moisture Survey'"
            >
              {{
                `${scan.depth}-${scan.depth + surveyReports[0].depthInterval}mm`
              }}
            </p>
            <p class="q-my-none" v-else>
              {{ `${scan.depth + 50}mm` }}
            </p>
          </div>
          <div
            class="col-6 text-center"
            :style="`background-color: ${getColor([
              scan.readings[geoPointRecording].value,
            ])}`"
          >
            {{ scan.readings[geoPointRecording].value }}
          </div>
        </div> -->
      </div>
      <div v-if="render" class="col-12">
        <div class="row">
          <div
            class="col"
            v-for="(survey, index) in currentZoomScanData"
            :key="`survey_${index}`"
          >
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="q-ma-xs" style="font-size: 12pt; line-height: 10pt">
                  {{ survey.name }}
                  <br />
                  <q-chip square size="xs" :color="graphColors[index]"></q-chip>
                  <q-btn
                    v-if="index != 0"
                    icon="close"
                    color="primary"
                    size="sm"
                    round
                    flat
                    @click="removeSurvey(survey.id)"
                  ></q-btn>
                  <q-btn
                    icon="map"
                    :color="currentMapIndex == index ? 'primary' : 'black'"
                    size="sm"
                    round
                    flat
                    @click="changeDisplayedMap(index)"
                  ></q-btn>
                </h6>
                <span style="top: -10px; position: relative">
                  250mm Scan Depth
                </span>
              </div>
            </div>
            <div
              class="row q-px-lg"
              v-if="survey.normalizedData[currentSelectedIndex]"
            >
              <div
                class="col-12 text-center"
                :style="`background-color: ${getColor([
                  survey.normalizedData[currentSelectedIndex].value,
                ])}`"
              >
                {{
                  roundTwoDP(survey.normalizedData[currentSelectedIndex].value)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <q-dialog v-model="settingsDialog">
      <q-card tile>
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Moisture Limit Settings
            </div>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div class="col-12 text-center">Adjust moisture limits</div>
            <div class="col-12">
              <q-input
                label="Concerning Moisture Limit (Red)"
                square
                standout
                type="number"
                suffix="TDRI Index"
                v-model.number="upperLimit"
                :rules="[(v) => !!v || 'Upper limit is required']"
              ></q-input>
            </div>
            <div class="col-12">
              <q-input
                label="Ideal Moisture Limit (Yellow)"
                square
                standout
                type="number"
                suffix="TDRI Index"
                :rules="[(v) => !!v || 'Lower limit is required']"
                v-model.number="lowerLimit"
              ></q-input>
            </div>
            <!-- <div class="col-12 text-center">
                Ad
              </div> -->
          </div>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="updateLowerAndUpperLimit()"
                class="full-width"
                color="positive"
                label="Confirm"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import googleMaps from "@/components/googleMaps/googleMaps.vue";
import pwaGraphComponent from "@/components/surveyReport/pwaGraphComponent.vue";
import LeafletMaps from "@/components/leaflet/leafletMaps.vue";

export default {
  components: { googleMaps, pwaGraphComponent, LeafletMaps },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentZoomScanData",
      "currentZoomScanDataLoading",
      "currentMapIndex",
      "nearestLocations",
      "nearestLocationsLoading",
      "currentSelectedIndex",
      "currentSelectedIndexRelative",
      "currentZoom",
      "currentViewedReports",
      "offlineMode",
      "survey",
    ]),
  },
  props: {
    source: String,
  },
  data: () => ({
    dot: true,
    line: true,
    graph: false,
    multiple: false,
    settingsDialog: false,
    geoPointRecording: 0,
    geoPointRecordingRange: {
      max: 0,
      min: 0,
    },
    sliderOptions: {
      min: 0,
      max: 1,
    },
    coords: {
      lat: 10,
      lng: 10,
    },
    render: false,
    upperLimit: 12,
    lowerLimit: 6,
    overlayAllData: false,
    selectedColor: "white",
    normalizedData: [],

    // options: ,

    testSynchronizedCharts: [0, 1],

    strokeColors: ["#008000", "#eb9c34", "#eb4034"],

    graphColors: ["green-10", "pink-6", "indigo-10"],
    updateCenterDebounce: null,
  }),
  beforeCreate() {},
  mounted() {
    this.$store.dispatch(
      "loadSurveyByID",
      this.$route.params.hasOwnProperty("id") ? this.$route.params.id : 5
    );

    // this.$store
    //   .dispatch("loadSurveyScanDataForZoom", {
    //     idList: [
    //       this.$route.params.hasOwnProperty("id") ? this.$route.params.id : 5,
    //     ],
    //     zoom: 5,
    //   })
    //   .then(() => {
    //     this.init();
    //   });
  },
  watch: {
    geoPointRecording() {
      this.calculateColor();
    },
    currentZoomScanData() {
      if (this.render == false) {
        this.init();
      } else {
        this.updateNormalizationData();
        this.updateNormalizedData();
      }
    },
    currentSelectedIndex() {
      this.slider = this.currentSelectedIndex;
      this.calculateColor();
    },
    survey: function () {
      let ids = this.survey.mergedScans
        ? this.survey.mergedScans.map((scan) => scan.merged_id)
        : [this.survey.id];
      this.$store
        .dispatch("loadSurveyScanDataForZoom", {
          idList: [ids],
          zoom: 5,
        })
        .then(() => {
          this.init();
        });
      this.slider = this.currentSelectedIndex;
    },
  },
  methods: {
    init() {
      this.$store.dispatch("changeCurrentMapIndex", 0);
      this.normalizedData = this.currentZoomScanData[0].normalizedData;
      this.graph = false;
      this.updateNormalizedData();
      this.lowerLimit = this.currentZoomScanData[0].lowerLimit;
      this.upperLimit = this.currentZoomScanData[0].upperLimit;
      setTimeout(() => {
        this.calculateColor();
        this.highlightPoint(0);
        this.$refs.gmapReport.zoomToBounds(
          this.calculateNESWBounds(0, this.normalizedData.length - 1)
        );
        this.render = true;
      }, 200);
    },
    setPosition(position) {
      this.coords.lng = position.lng;
      this.coords.lat = position.lat;
    },
    updateCenterPOS(index) {
      clearTimeout(this.updateCenterDebounce);
      this.updateCenterDebounce = setTimeout(() => {
        this.$emit(
          "panToLocation",
          this.currentZoomScanData[this.currentMapIndex].normalizedData[index],
          index
        );
        this.$store.dispatch("changeSelectedIndex", index);
        this.$refs.gmapReport.panToLocation(this.normalizedData[index]);
      }, 25);
    },
    highlightPoint(index) {
      this.$refs.gmapReport.panToLocation(this.normalizedData[index], true);
    },
    runError(error) {
      this.$q.notify({
        position: "top-right",
        type: "error",
        message: error.message,
      });
    },
    calculateColor() {
      let color =
        this.$refs.gmapReport.strokeColors[
          this.normalizedData[this.geoPointRecording].value < this.lowerLimit
            ? 0
            : this.normalizedData[this.geoPointRecording].value >
              this.upperLimit
            ? 2
            : 1
        ];
      this.selectedColor = color;
    },
    getColor(value) {
      let color =
        this.$refs.gmapReport.strokeColors[
          value < this.lowerLimit ? 0 : value > this.upperLimit ? 2 : 1
        ];
      return color;
    },
    rangeChanged() {
      let min = this.geoPointRecordingRange.min;
      let max = this.geoPointRecordingRange.max;
      let middle = Math.floor((max + min) / 2);
      this.updateCenterPOS(middle);
      setTimeout(() => {
        this.$refs.chart.zoom(min, max);
        this.$refs.gmapReport.zoomToBounds(this.calculateNESWBounds(min, max));
        this.$refs.gmapReport.drawRangePoints(
          this.normalizedData[min],
          this.normalizedData[max]
        );
      }, 50);
    },
    calculateNESWBounds(min, max) {
      let data = {
        maxLng: -500,
        minLng: 500,
        maxLat: -500,
        minLat: 500,
      };
      for (let index = min; index <= max; index++) {
        data.maxLat =
          this.normalizedData[index].lat > data.maxLat
            ? this.normalizedData[index].lat
            : data.maxLat;

        data.minLat =
          this.normalizedData[index].lat < data.minLat
            ? this.normalizedData[index].lat
            : data.minLat;

        data.maxLng =
          this.normalizedData[index].lng > data.maxLng
            ? this.normalizedData[index].lng
            : data.maxLng;

        data.minLng =
          this.normalizedData[index].lng < data.minLng
            ? this.normalizedData[index].lng
            : data.minLng;
      }
      return data;
    },
    dotClicked(point) {
      this.$store.dispatch("changeSelectedIndex", point);
    },
    toggleGraphSettings() {
      if (this.graph) {
        this.rangeChanged();
      }
    },

    handleNewZoomLevel(zoom) {
      if (
        (zoom > this.currentZoom || zoom <= this.currentZoom - 3) &&
        zoom <= 18
      ) {
        clearTimeout(this.zoomDebounce);
        this.zoomDebounce = setTimeout(() => {
          this.$store.dispatch("loadSurveyScanDataForZoom", {
            idList: this.currentViewedReports,
            zoom: zoom,
          });
        }, 1000);
      }
    },
    updateNormalizedData() {
      this.sliderOptions.max =
        this.currentZoomScanData[this.currentMapIndex].normalizedData.length -
        1;
      this.geoPointRecordingRange.max =
        this.currentZoomScanData[this.currentMapIndex].normalizedData.length -
        1;
    },
    updateNormalizationData() {
      this.$store.dispatch(
        "changeSelectedIndex",
        Math.round(
          this.currentZoomScanData[this.currentMapIndex].normalizedData.length *
            this.currentSelectedIndexRelative
        )
      );
      setTimeout(() => {
        this.normalizedData =
          this.currentZoomScanData[this.currentMapIndex].normalizedData;
      }, 500);
    },
    roundTwoDP(val) {
      return Math.round((parseFloat(val) + Number.EPSILON) * 100) / 100;
    },
  },
};
</script>

<style>
#reportSlider > .q-slider__track-container {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
